/* apps/viewer/src/app/layout/layout.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host ::ng-deep {
  display: flex;
  flex-direction: column;
  height: inherit;
}
:host ::ng-deep mat-sidenav-container {
  height: 100%;
  min-height: calc(100vh - 60px);
  overflow: unset;
}
:host ::ng-deep mat-sidenav-container .mat-sidenav {
  max-width: 500px;
  min-width: 280px;
  position: fixed;
  width: 25%;
}
:host ::ng-deep mat-sidenav-container .toc-sidenav,
:host ::ng-deep mat-sidenav-container .settings-sidenav {
  margin-top: 60px;
}
:host ::ng-deep mat-sidenav-container .mat-sidenav-content.mat-drawer-content {
  display: flex;
  flex-direction: column;
  height: inherit;
  overflow: inherit !important;
  position: relative;
}
:host ::ng-deep mat-sidenav-container .mat-sidenav-content.mat-drawer-content o-search-result {
  overflow: inherit !important;
}
:host ::ng-deep .mat-sidenav-content.is-sticky-parent o-header.is-sticky {
  box-shadow: none;
  transition: all ease 1s;
}
.toc-sidenav .toc-header::after {
  background: black;
  content: "";
  display: block;
  height: 100%;
  opacity: 0.6;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
}
.toc-sidenav .toc-header {
  align-items: center;
  background-image: initial;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
  color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 0;
  position: relative;
}
.toc-sidenav .toc-header .mat-icon {
  color: white;
  margin: 0;
}
.toc-sidenav .pub-infos {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  justify-content: space-between;
  margin: 0;
  padding: 10px;
  width: 100%;
  z-index: 1;
}
.toc-sidenav .pub-infos .title {
  font-size: 16px;
  font-weight: bold;
}
.toc-sidenav .revision {
  align-items: center;
  background: transparent;
  display: flex;
  height: 24px;
  line-height: 24px;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
.toc-sidenav .revision .flag-icon {
  margin-right: 10px;
}
button {
  align-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 40px;
  margin: 2px;
  width: 100%;
}
.applic,
.back {
  color: #fafafa;
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  padding: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
}
.applic {
  align-items: center;
  display: flex;
  margin-left: auto;
}
.applic:hover {
  cursor: pointer;
}
.back-button {
  justify-content: flex-start;
  margin: 0;
  z-index: 1;
}
.applic-button {
  justify-content: flex-end;
  margin: 0;
  z-index: 1;
}
.logout {
  transform: rotate(180deg);
}
o-player {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: -10000;
}
@media print {
  ::ng-deep mat-sidenav-container ::ng-deep .mat-sidenav-content.mat-drawer-content {
    display: block !important;
  }
  .settings-sidenav {
    display: none;
  }
  .toc-sidenav {
    display: none;
  }
  ::ng-deep mat-sidenav-content {
    margin-left: 0 !important;
  }
  ::ng-deep snack-bar-container {
    display: none !important;
  }
}
/*# sourceMappingURL=layout.component.css.map */
